import { memo } from 'react';

import type { OTCDealData } from '@src/types/OTC';
import {
  isFixedRateLoanDeal,
  isFloatingRateLoanDeal,
  isForwardDeal,
  isOptionDeal,
  isRepoDeal,
} from '@src/types/OTC/otcGuards';

import { DealCardFixedRateLoan } from './DealCardFixedRateLoan';
import { DealCardFloatingRateLoan } from './DealCardFloatingRateLoan';
import { DealCardForward } from './DealCardForward';
import { DealCardOption } from './DealCardOption';
import { DealCardRepo } from './DealCardRepo';

interface DealCardProps {
  deal: OTCDealData;
}

export const DealCard = memo(function DealCard({ deal }: DealCardProps) {
  // Render the appropriate specialized component based on deal type
  if (isForwardDeal(deal)) {
    return <DealCardForward deal={deal} />;
  }

  if (isFixedRateLoanDeal(deal)) {
    return <DealCardFixedRateLoan deal={deal} />;
  }

  if (isFloatingRateLoanDeal(deal)) {
    return <DealCardFloatingRateLoan deal={deal} />;
  }

  if (isOptionDeal(deal)) {
    return <DealCardOption deal={deal} />;
  }

  if (isRepoDeal(deal)) {
    return <DealCardRepo deal={deal} />;
  }

  return null;
});
